"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Compares to arrays of strings for equality of
 * items. Does not take into account the order of
 * the items.
 *
 * @param array1 An array of strings.
 * @param array2 An array of strings.
 */
function stringArraysEqual(array1, array2) {
    // If the lengths are different
    // the arrays can't be equal
    if (array1.length !== array2.length) {
        return false;
    }
    var equal = true;
    // Check that all array1 items are
    // found in array2
    array1.forEach(function (item) {
        if (!array2.includes(item)) {
            equal = false;
        }
    });
    // Check that all array2 items are
    // found in array1
    array2.forEach(function (item) {
        if (!array1.includes(item)) {
            equal = false;
        }
    });
    return equal;
}
exports.default = stringArraysEqual;
//# sourceMappingURL=stringArraysEqual.js.map